module.exports = "/assets/1c7e6471d2bdf7c6292ed0086f09ccca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8M.png
// module id = 1140
// module chunks = 0